export default __webpack_public_path__ + "static/media/img2.77f53746.webp";